import { selectFlatNavLinks } from '~/app/navLinks'
import { AstraIcon, AstraTooltip, IconComponent } from '~/astra'
import { useStore } from '~/store/store'

export const ThreadSourceIcon = ({ sourcePath }: { sourcePath: string }) => {
    const flatNavLinks = useStore(selectFlatNavLinks)
    const navLinkItem = flatNavLinks.find(link => sourcePath.startsWith(link.url))

    if (!navLinkItem) {
        return null
    }

    return (
        <AstraTooltip tooltipContent={`Opprettet i ${navLinkItem.title}`}>
            <AstraIcon icon={navLinkItem.icon as IconComponent} size="small" color="text-subtle" />
        </AstraTooltip>
    )
}
